export default __webpack_public_path__ + "static/media/SoundCloud.f8d996a2.svg";